
import { types } from "../types/types"
import { recuperarHistorial, recuperarHistorial2 } from "./configAppAction";






export const recuperarConfigUsuari = (token) =>{
    //Aquesta funció (Middleware), retorna un callback. Just quan finalitza la petició, execitarà l'acció 
    return (dispatch) =>{
        dispatch(ConfigUsuariRecuperarInfoIniciat(true));
        //dispatch(uiIniciarCarregaAction());      
            const requestOptions = {
                method: 'GET',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8','Accept':'application/json','Authorization' : token },
                credentials: 'include',
                mode: 'cors'
            };
            //TODO - Crear un fitxer on guardem constants segons l'entorn 
        fetch( process.env.REACT_APP_DOMINI_API_CIUDAD + '/datos/responsable',requestOptions)
            .then(async response => {
          
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
                
        
                // check for error response
                if (!response.ok) {
                    
                    // get error message from body or default to response status
                    //const error = (data && data.message) || response.status;
                    //dispatch(crearErrorAction("Error del servei d'autenticació: " +  JSON.stringify(data)));
                }else
                {
                    if(data.ok)
                    {
                        dispatch(ConfigUsuariRecuperarInfoFinalitzat(true,data.contingut));
                        
                        if(data.contingut.admin == 1){
                            dispatch(recuperarHistorial2(token,data.contingut.id,data.contingut.IdMunicipio)); 
                        }else {
                            dispatch(recuperarHistorial(token,data.contingut.id,data.contingut.IdMunicipio)); 
                        }
                    }else{

                    }
                }

                //dispatch(uiFinalitzarCarregaAction());
                //element.innerHTML = data.id;
            })
            .catch(error => {
               // element.parentElement.innerHTML = `Error: ${error}`;
               // dispatch(crearErrorAction("Excepció no controlada -  " + JSON.stringify(error)));
                console.error('There was an error!', error);
               // dispatch(uiFinalitzarCarregaAction());
            });
      
        /*setTimeout(() => {
                //Als 3 segons, farem un dispatch del l'acció Login. 
                
                dispatch(login(123,345,"German, usuari autenticat"));

            }, 3500);*/
    }


}







export const ConfigUsuariRecuperarInfoIniciat = (iniciat) =>{
    return {
        type: types.configUsuariRecuperarInfo,
        iniciat
    }

}

export const ConfigUsuariRecuperarInfoFinalitzat = (finalitzat,contingut) =>{
    return {
        type: types.configUsuariRecuperarInfoFinalitzada,
        finalitzat,
        contingut
    }

}